export function formatNumberByThousands(x?: number | string | null): string | null {
  if (x == null) return null;

  const num = Number(x);

  if (Number.isNaN(num)) {
    return null;
  }

  return num.toLocaleString("en-US");
}
